import type { CosmeticSlot } from '~/stores/character'

/** Slots that bypass character compatibility — they fit any character. */
export const CHARACTER_INDEPENDENT_SLOTS: readonly CosmeticSlot[] = ['pet', 'background']

export function isCharacterIndependentSlot(slot: CosmeticSlot): boolean {
  return CHARACTER_INDEPENDENT_SLOTS.includes(slot)
}
